let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6sNMH")).then(() => parcelRequire('7w5tu'));